import AssignmentContract from 'app/modules/account/ui/components/common/assignement-contract/assignement-contract';
import NoMatchedAdhesion from 'app/modules/account/ui/components/common/no-matched-adhesion';
import SearchContract from 'app/modules/account/ui/components/common/search-contract/search-contract';
import ConfirmationMail from 'app/modules/contact/ui/components/mobile/confirmation.mail/confirmation_mail';
import contractRescindConfirmation from 'app/modules/contract/ui/components/mobile/mobile-contract-rescind/rescind-confirmation';
import rescindSourceChoice from 'app/modules/contract/ui/components/mobile/mobile-contract-rescind/rescind-source-choice';
import RescindTelepohone from 'app/modules/contract/ui/components/mobile/mobile-contract-rescind/rescind-telephne-mode';
import paybox from 'app/modules/contract/ui/components/mobile/mobile-cotisation/payBox';
import { ERRORMESSAGE } from 'app/modules/contract/ui/tools/constants';
import { ILogisticModel } from 'app/modules/logistic/model/logistic.model';
import { DeviceType } from 'app/modules/rules/domain/Device.type';
import AccountAssignementEngine from 'app/pages/common/account-assignement';
import { Logout } from 'app/pages/common/logout/logout';
import { ClaimListPage } from 'app/pages/mobile/claim/claim';
import ClaimEngine from 'app/pages/mobile/claim/claim-engine';
import ContactEngine from 'app/pages/mobile/contact/contact';
import Home from 'app/pages/mobile/contract/contract';
import ContractEngine from 'app/pages/mobile/contract/contract-engine';
import contractRescind from 'app/pages/mobile/rescind/index';
import { base64StringToBlob } from 'blob-util';
import { isMobile } from 'react-device-detect';
import { RouteComponentProps } from 'react-router-dom';
import { ColorAndBorder, cssColorClass, leftBorderColor } from './constants';

export function colorCssByCodeStatus(codeStatus: any, statusList: any) {
  return (statusList || []).find(element => element.code === codeStatus)?.style_color || '#00ab7d';
}

export function labelStatusByCodeStatus(codeStatus: any, statusList: any, valDefault?: string) {
  return (statusList || []).find(element => element.code.toString() === codeStatus.toString())?.label || valDefault;
}

export function isValidToView(consistOf: any, code: any) {
  return (consistOf || [])?.find(element => element.code === code) ? true : false;
}

export function getConsistOfItem(consistOf: any, code: any) {
  return consistOf.find(element => element.code === code);
}

export function getCSSColorbyStatusCode(codeStatus: any) {
  return cssColorClass[codeStatus];
}

export function getleftBorderColor(codeStatus: any) {
  return leftBorderColor[codeStatus];
}

export function getCSSColorAndBorder(codeStatus: any) {
  return ColorAndBorder[codeStatus];
}

export const renderSwitch = size => {
  switch (size) {
    case 'XS':
      return 12;
    case 'M':
      return 14;

    case 'D':
      return 13;

    default:
      return 12;
  }
};
export const styleText = key => {
  switch (key) {
    case 'titel':
      return 600;

    default:
      return 500;
  }
};

export const checkRequired = name => {
  // ERRORMESSAGE.hasOwnProperty(name+"Required");
  if (name + 'Required' in ERRORMESSAGE) {
    return true;
  }
  return false;
};

export const a11yProps = (index: any) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
};

export const setStylesProperties = (data: any): any => {
  document.documentElement.style.setProperty('--active-item-background-color', data?.primary_color + '30');
  document.documentElement.style.setProperty('--background-color', data?.background_color);
  document.documentElement.style.setProperty('--background-image', 'url(' + data?.background_image?.url + ') no-repeat top center');
  document.documentElement.style.setProperty(
    '--background-layout-container-image',
    'url(' + data?.background_layout_container_image?.url + ') calc(100% - 1.5rem) calc(100% - 5rem) / 21% no-repeat fixed'
  );
  document.documentElement.style.setProperty('--left-image', 'url(' + data?.left_image?.url + ') no-repeat fixed');
  document.documentElement.style.setProperty('--main-chat', 'url(' + data?.chat_icon?.url + ')');
  // document.documentElement.style.setProperty('--product_chat_icon', 'url(' + data?.product_chat_icon?.url + ')');
  document.documentElement.style.setProperty('--main-logo', 'url(' + data?.main_logo?.url + ')');
  document.documentElement.style.setProperty('--clickable-color', data?.clickable_color);
  document.documentElement.style.setProperty('--fail-color', data?.failColor);
  document.documentElement.style.setProperty('--field-information-color', data?.fieldInformationColor);
  document.documentElement.style.setProperty('--form-background-color', data?.form_background_color);
  document.documentElement.style.setProperty('--hover-main-clickable-color', data?.hoverMainClickableColor);
  document.documentElement.style.setProperty('--hover-secondary-clickable-color', data?.hoverSecondaryClickableColor);
  document.documentElement.style.setProperty('--information-color', data?.informationColor);
  document.documentElement.style.setProperty('--primary-color', data?.primary_color ? data?.primary_color : '#00a9d8');
  document.documentElement.style.setProperty('--success-color', data?.successColor);
  document.documentElement.style.setProperty('--text-color', data?.text_color);
  document.documentElement.style.setProperty('--warning-color', data?.warningColor);
  document.documentElement.style.setProperty('--panel-opened-color', data?.panelOpenedColor);
  document.documentElement.style.setProperty('--item_tab_color', data?.item_tab_color);
};

export const refreshScroll = () => {
  const activeSlide = document.querySelector('.slick-list .slick-active');
  const observer = new MutationObserver(() => {
    const x = document.querySelector<HTMLElement>('.slick-list');
    if (x) x.style.height = `auto`;
  });
  activeSlide && observer.observe(activeSlide, { childList: true, subtree: true });
};

export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const openFile = bonTransportBase64 => {
  const encodedData = bonTransportBase64;
  const type = 'application/pdf';
  const blob = b64toBlob(encodedData, type);
  const blobUrl = URL.createObjectURL(blob);
  const windowObject = window.open('location=no,enableviewportscale=yes');
  if (type.includes('pdf')) {
    windowObject.document.write(
      "<iframe frameborder='0' width='100%' scrolling='no' style='margin: -10px;overflow:hidden;' height='100%' src='" +
      blobUrl +
      "'></iframe>"
    );
  }
};

export const dowloadFile = logisticResponse => {
  const type = 'application/pdf';
  if (type.includes('pdf')) {
    const encodedData = logisticResponse.bonTransportBase64;
    const blob = base64StringToBlob(encodedData, type);
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = window.URL.createObjectURL(blob);
    setTimeout(() => {
      link.click();
    }, 70);
  }
};
export const dowloadContractuelDoc = base64Data => {
  const type = 'application/pdf';
  if (type.includes('pdf')) {
    const encodedData = base64Data;
    const blob = base64StringToBlob(encodedData, type);
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = window.URL.createObjectURL(blob);
    setTimeout(() => {
      link.click();
    }, 70);
  }
};

export const constructBpObject = (generationLink: string, logisticModel: ILogisticModel) => {
  if (generationLink?.includes('generate_bon_transport')) {
    const url = new URL('http://' + generationLink);

    const providerVal = generationLink?.substring(generationLink?.lastIndexOf('/') + 1, generationLink?.lastIndexOf('?'));
    const logistic: ILogisticModel = {
      idProvider: providerVal,
      operationType: 'FIND',
      adhesionNumber: url.searchParams.get('adhesion'),
      claimNumber: url.searchParams.get('claimNumber'),
      trackingNumber: url.searchParams.get('trackingNumber'),
      mail: logisticModel?.mail,
      sequenceNumber: logisticModel?.sequenceNumber,
      codePointRelais: logisticModel?.codePointRelais,
    };
    return logistic;
  }
};

export const upperCaseFirstLetter = string => {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1);
};

function titleCase(str) {
  const splitStr = str.toLowerCase().split(' ');
  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(' ');
}

export const lowerCaseAllWordsExceptFirstLetters = string => {
  const valeu = string?.replace(/\S*/g, function (word) {
    return word.charAt(0) + word.slice(1).toLowerCase();
  });

  const valuemap = valeu.split('-');

  const test = '';
  const resulta = valuemap.map((item, index) => (index !== 0 ? '-' : '') + test + item.charAt(0).toUpperCase() + item.slice(1)) || '';
  let element = '';
  for (let index = resulta?.length - 1; index >= 0; index--) {
    element = resulta[index] + element;
  }
  return element;
};

export const findProviderLabel = string => {
  switch (string) {
    case '21':
      return 'CDN';
    case '30':
      return 'TS';
    case '3':
      return 'TS';
    default:
      return null;
  }
};

export const showDownloadBpButton = (providerCode: string, processCode: string) => {
  switch (processCode) {
    case '912': {
      if (providerCode === '21' || providerCode === '30') return true;
      return false;
    }
    case '982':
      return true;
    case '983':
      return true;
    case '2116': {
      if (providerCode === '3') return true;
      return false;
    }
    default:
      return false;
  }
};

export const getAttributUrl = (urlQueryString, attributKey) => {
  const queryString = urlQueryString;
  const parameters = new URLSearchParams(queryString);
  return parameters.get(attributKey) || '';
};

export const componentImportName = {
  Home: Home as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  Logout: Logout as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  ContactMobile: ContactEngine as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  ClaimListPage: ClaimListPage as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  ContractEngine: ContractEngine as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  ConfirmationMail: ConfirmationMail as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  ClaimEngine: ClaimEngine as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  contractRescind: contractRescind as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  contractRescindConfirmation: contractRescindConfirmation as
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>
    | undefined,
  rescindSourceChoice: rescindSourceChoice as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  SearchContract: SearchContract as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  AccountAssignementEngine: AccountAssignementEngine as
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>
    | undefined,
  AssignmentContract: AssignmentContract as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  RescindTelepohone: RescindTelepohone as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  paybox: paybox as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  NonCorespondenceadhesion: NoMatchedAdhesion as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
};

export function findStatusCmsInfo(cmsData: any, code?: any, key?: any) {
  return (cmsData || []).find(code ? e => e.code === code.toString() : e => e.key === key);
}

export function noLog() {
  console.log = () => { };
  console.error = () => { };
  console.debug = () => { };
}

export function getInfoInsured(data: any) {
  return {
    imei: (data?.insuredProduct?.insureGods && data?.insuredProduct?.insureGods[0]?.features[15]) || '',
    brand: data?.insuredProduct?.insureGods && data?.insuredProduct?.insureGods[0]?.brand,
    model: data?.insuredProduct?.insureGods && data?.insuredProduct?.insureGods[0]?.model,
    purchaseDate: data?.insuredProduct?.insureGods && data?.insuredProduct?.insureGods[0]?.purchaseDate,
  };
}

export function showAttributs(constraintkey, params) {
  return Object.entries(params).find(([key, value]) => key === constraintkey) ? true : false;
}

export function replaceDocumentsCms(text, param, to) {
  return text.replace(param, to);
}

export function getCmsValue(keyItems: any, cmsitems: [any]) {
  return cmsitems && cmsitems?.find(x => x.key === keyItems);
}

export function validURL(str) {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' +
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
    '((\\d{1,3}\\.){3}\\d{1,3}))' +
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
    '(\\?[;&a-z\\d%_.~+=-]*)?' +
    '(\\#[-a-z\\d_]*)?$',
    'i'
  );
  return !!pattern.test(str);
}

export function isMobileDevice(configuration) {
  return configuration?.device === DeviceType.MOBILE || (configuration?.device === DeviceType.ALL && isMobile);
}


export function maskInfo(info: string) {

  if (info?.length === 0) return info;

  if (info?.length < 5) return "XXX";

  const firstTwo = info?.substring(0, 2);
  let result = "";
  for (let i = 2; i < info?.length - 3; i++) {
    if (info[i] !== '@') {
      result += "X";
    } else {
      result += "@";
    }
  }
  const lastTwo = info?.substring(info?.length - 3, info?.length);

  return firstTwo + result + lastTwo;
}

export function isEmptyObject(obj) {
  return !(typeof obj === 'object' && obj != null && Object.keys(obj).length !== 0);
}